import { render, staticRenderFns } from "./AdminJobs.vue?vue&type=template&id=665dcc7e"
import script from "./AdminJobs.vue?vue&type=script&lang=js"
export * from "./AdminJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports